import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";

// Chat bubble: user right (40%), assistant left (60%). Content never overflows past center.
export const ChatBubble = ({ role, children }: { role: "user" | "assistant"; children: ReactNode }) => {
  const isUser = role === "user";
  const maxWidthPercent = isUser ? "60%" : "90%";
  const textAlign = isUser ? "left" : "left";

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: isUser ? "flex-end" : "flex-start",
        width: "100%",
        pb: 1,
      }}
    >
      <Box
        sx={{
          maxWidth: maxWidthPercent,
          minWidth: 0, // allow shrink so long content wraps
          bgcolor: "transparent",
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: PureLightThemeCaaS.colors.alpha.orange[100],
            fontSize: "12px",
            fontWeight: "bold",
            display: "block",
            textAlign,
            pt: isUser ? 2 : 0,
          }}
        >
          {isUser ? "You" : "RotoGPT"}
        </Typography>
        <Box
          sx={{
            color: PureLightThemeCaaS.colors.alpha.white[100],
            textAlign,
            overflowWrap: "break-word",
            wordBreak: "break-word",
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};